export default {
 methods:{
   autoResizing(o)
   {
     let element =  document.getElementById('herss');
     let scrollLeft = element.scrollLeft;
     let scrollTop = element.scrollTop;
     let currentX = o.pointer.x*this.canvas.getZoom();
     let currentY = o.pointer.y*this.canvas.getZoom();
     let diff;

     if(Math.abs(currentX - scrollLeft) <= 40){
       element.scrollLeft = scrollLeft - 20;
     }

     if(Math.abs(currentY - scrollTop) <= 40){
       element.scrollTop = scrollTop - 20;
     }


     if(Math.abs(currentX - this.canvas.width) <= 40){
       this.canvas.setWidth(this.canvas.width + 100);
       this.canvas.renderAll();
     }

     diff = element.clientWidth + element.scrollLeft;
     if(diff - currentX <= 60){
       element.scrollLeft =element.scrollLeft + 20;
     }

     if(Math.abs(currentY - this.canvas.height) <= 40){
       this.canvas.setHeight(this.canvas.height + 100);
       this.canvas.renderAll();
     }
     diff = element.clientHeight+ element.scrollTop;
     if(diff - currentY <= 60){
       element.scrollTop = element + 20;
     }
   }
 }
}
